import { styled } from "@vw-marketing/us-components";

export const StyledInfoToolTipContainer = styled.div`
  align-items: center;
  color: rgb(0, 30, 80);
  cursor: pointer;
  display: flex;
  margin: 0 2px;

  &::hover {
      color: rgb(0, 64, 197);
  }
`;
